import type { TopCampaignsResult } from "../api";

export function CampaignsTable({
    campaigns,
    unattributed,
    currency,
}: {
    campaigns: TopCampaignsResult;
    unattributed: { revenue: number; orders: number };
    currency: string;
}) {
    const fmt = (n: number) =>
        n.toLocaleString(undefined, { style: "currency", currency, maximumFractionDigits: 0 });
    const maxSpend = Math.max(...campaigns.items.map((i) => i.spend), 1);
    return (
        <div className="bg-okiru-panel border border-okiru-muted/15 rounded-xl p-5 flex flex-col h-full min-h-0">
            <div className="flex items-baseline justify-between mb-4">
                <h3 className="text-sm uppercase tracking-wide text-okiru-muted">Campaigns</h3>
                <div className="text-xs text-okiru-muted">sorted by spend</div>
            </div>
            {campaigns.items.length === 0 ? (
                <div className="text-okiru-muted text-sm">No campaigns with spend in this range.</div>
            ) : (
                <div className="flex-1 min-h-0 overflow-y-auto">
                <table className="w-full text-sm">
                    <thead className="sticky top-0 bg-okiru-panel z-10">
                        <tr className="text-okiru-muted text-xs uppercase tracking-wide">
                            <th className="text-left font-normal pb-3">Campaign</th>
                            <th className="text-right font-normal pb-3">Spend</th>
                            <th className="text-right font-normal pb-3">Revenue</th>
                            <th className="text-right font-normal pb-3">Orders</th>
                            <th className="text-right font-normal pb-3">ROAS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {campaigns.items.map((c) => (
                            <tr key={c.campaign_id} className="border-t border-okiru-muted/10">
                                <td className="py-2 pr-4">
                                    <div className="truncate max-w-xs">{c.campaign_name}</div>
                                    <div className="h-1 bg-okiru-bg rounded mt-1.5">
                                        <div
                                            className="h-full bg-okiru-accent rounded"
                                            style={{ width: `${(c.spend / maxSpend) * 100}%` }}
                                        />
                                    </div>
                                </td>
                                <td className="text-right whitespace-nowrap py-2">{fmt(c.spend)}</td>
                                <td className="text-right whitespace-nowrap py-2">{fmt(c.revenue)}</td>
                                <td className="text-right whitespace-nowrap py-2">{c.orders}</td>
                                <td className="text-right whitespace-nowrap py-2">
                                    {c.spend > 0 ? `${c.roas.toFixed(2)}×` : "—"}
                                </td>
                            </tr>
                        ))}
                        <tr className="border-t border-okiru-muted/30 text-okiru-muted italic">
                            <td className="py-2 pr-4">(unattributed)</td>
                            <td className="text-right whitespace-nowrap py-2">—</td>
                            <td className="text-right whitespace-nowrap py-2">{fmt(unattributed.revenue)}</td>
                            <td className="text-right whitespace-nowrap py-2">{unattributed.orders}</td>
                            <td className="text-right whitespace-nowrap py-2">—</td>
                        </tr>
                    </tbody>
                </table>
                </div>
            )}
        </div>
    );
}
